import {
  ListCellsSelectionItemContainer as DesignListCellsSelectionItemContainer,
  ListCellsSelectionItemContainerProps,
} from '@bts-web/design-system/component/list-cells-selection';
import { css } from '@bts-web/utils-style-engine';
import { dividerStyles, transparentDividerStyles } from './styles';

const displayFlexWithCenteredItems = {
  display: 'flex',
  alignItems: 'center',
};

const labelLargeTypography = {
  fontSize: 'label.large',
  fontWeight: 'label.large',
  lineHeight: 'label.large',
  letterSpacing: 'label.large',
};

const captionMediumTypography = {
  fontSize: 'caption.medium_medium',
  fontWeight: 'caption.medium_medium',
  lineHeight: 'caption.medium_medium',
  letterSpacing: 'caption.medium_medium',
};

const ListCellsSelectionItemContainer = ({
  activeItemId,
  children,
  isDisabled = false,
  separator = false,
  itemId,
  icon,
  label,
  subLabel,
  isActive,
  hasBorder = true,
}: ListCellsSelectionItemContainerProps & {
  activeItemId?: string;
  isDisabled?: boolean;
  separator?: boolean;
  isActive?: boolean;
  hasBorder?: boolean;
}) => {
  const isItemActive = isActive ?? activeItemId === itemId;

  const visual = isDisabled ? 'disabled' : isItemActive ? 'active' : 'default';

  return (
    <>
      <DesignListCellsSelectionItemContainer
        className={css({
          ...displayFlexWithCenteredItems,
          backgroundColor: 'screen_background.primary',
          ...(hasBorder
            ? {
                border: '1px solid',
                borderColor: 'neutrals.stroke_secondary',
                borderRadius: '12px',
              }
            : {}),
          '&:hover, &:focus': {
            backgroundColor: 'neutrals.fill_focused',
          },
          '& > label': {
            display: 'flex',
            gap: 'small',
            alignItems: 'center',
            width: '100%',
            padding: 'medium',

            '& > [data-element="text-content"]': {
              display: 'flex',
              flexDirection: 'column',
              gap: 'extra_small_3',

              '& span:first-child': {
                ...displayFlexWithCenteredItems,
                ...labelLargeTypography,
                flexGrow: 1,
                gap: 'small',
              },
              '& span:nth-child(2)': {
                ...captionMediumTypography,
                color: 'neutrals.text_secondary',
              },
            },
          },
          '& > .item-slot:not(:empty)': {
            padding: 'medium',
          },
          ...(visual === 'default'
            ? {
                background: 'transparent',
                color: 'neutrals.text_primary',
              }
            : {}),
          ...(visual === 'active'
            ? {
                backgroundColor: 'neutrals.fill_focused',
                color: 'neutrals.text_primary',
              }
            : {}),
          ...(visual === 'disabled'
            ? {
                pointerEvents: 'none',
                backgroundColor: 'neutrals.fill_disabled',
                color: 'neutrals.text_disabled',
                '& [data-element="icon"]': {
                  backgroundColor: 'neutrals.fill_disabled',
                  color: 'brand.on_fill_primary',
                },
              }
            : {}),
        })}
        icon={icon}
        itemId={itemId}
        label={label}
        subLabel={subLabel}
      >
        {children}
      </DesignListCellsSelectionItemContainer>

      {separator && (
        <div
          className={!isItemActive ? dividerStyles : transparentDividerStyles}
        />
      )}
    </>
  );
};

export { ListCellsSelectionItemContainer };
